import { render } from "./setters.vue?vue&type=template&id=7e46cf58"
import script from "./setters.vue?vue&type=script&lang=js"
export * from "./setters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__